import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ProjectsListHeader} from './components/header/ProjectsListHeader'
import {ProjectsTable} from './table/ProjectsTable'
import {KTCard} from '../../../../../../_metronic/helpers'
import {usePermissions} from '../../../../../..//hook//permissions'

const ProjectsList = () => {
  const {itemIdForUpdate} = useListView()

  //maneira de chamar o hook pode ser desframentado em: show, edit, delete, create e roles
  //parametro enviado para o hook é o nome do cadastro em português conforme vem do back-end
  const {show} = usePermissions('Projetos')

  //estrutura de testes de permissoes
  //fim estrutura de testes de permissoes

  return (
    <>
      <KTCard className='pb-5'>
        <ProjectsListHeader />
      </KTCard>
      <div className='py-3'>
        {/* condicional de exibição da tabela */}
        <KTCard>{show && <ProjectsTable />}</KTCard>
      </div>
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const ProjectsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ProjectsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ProjectsListWrapper}
